import React from "react";
import { Select } from "antd";
import {
  SETTLE_LIST_SCOPE,
  SETTLE_LIST_SCOPE_OPTIONS,
} from "functions/merchant/merchantSettleListConstants";

/**
 * Settle list scope filter (shared admin + merchant). API: hasPending=true when HAS_PENDING_UNSETTLED.
 *
 * @param {string} value - SETTLE_LIST_SCOPE.*
 * @param {(scope: string) => void} onChange
 */
const MerchantSettleListScopeSelect = ({ value, onChange }) => (
  <Select
    id="merchant-settle-list-scope-select"
    aria-label="Өндөрлөлтийн жагсаалтын шүүлт"
    value={value}
    className="min-w-[240px]"
    size="small"
    placeholder="Жагсаалтын шүүлт"
    onChange={onChange}
    options={SETTLE_LIST_SCOPE_OPTIONS}
  />
);

export default MerchantSettleListScopeSelect;
